import axios from "axios";

const API_URL = "/api/enquiry";

const getHeaders = () => {
  const token = localStorage.getItem("accessToken");
  return {
    "Content-Type": "application/json",
    ...(token && { Auth: token }),
  };
};

const handleRequest = async (url, options = {}) => {
  try {
    const response = await axios({
      url,
      method: options.method || "GET",
      headers: getHeaders(),
      data: options.data,
    });

    const data = response.data;

    // If backend already wraps with success/data/message, pass it through
    if (data && typeof data.success !== "undefined") {
      return data;
    }

    return {
      success: true,
      data,
      message: data?.message || "",
    };
  } catch (error) {
    const status = error.response?.status;
    const data = error.response?.data;
    let message = data?.message;

    if (!message) {
      if (status === 401 || status === 403) {
        message = "You are not authorized to perform this action.";
      } else if (status >= 500) {
        message = "Server error occurred. Please try again later.";
      } else if (status) {
        message = "Request failed. Please try again.";
      } else {
        message = "Network error. Please check your internet connection.";
      }
    }

    return {
      success: false,
      data: null,
      message,
    };
  }
};

export const enquiryService = {
  // Fetch all enquiries
  getEnquiries: async () => {
    const result = await handleRequest(API_URL, {
      method: "GET",
    });
    return result;
  },

  // Update enquiry status
  updateEnquiryStatus: async (id, status) => {
    const result = await handleRequest(`${API_URL}/${id}`, {
      method: "PUT",
      data: { status },
    });
    return result;
  },

  // Delete enquiry
  deleteEnquiry: async (id) => {
    const result = await handleRequest(`${API_URL}/${id}`, {
      method: "DELETE",
    });
    return result;
  },
};
